__turbopack_context__.v({
  "className": "nunito_2246961d-module__uCj7xW__className",
});
